import React from "react";
import { Accordion, Col, Row } from "react-bootstrap";
import SingleLink from "./SingleLink";

const DropDownLink = ({ link }) => {
  return (
    <React.Fragment>
      <Accordion flush>
        <Accordion.Item>
          <Accordion.Header>
            <Row>
              <Col
                sm={3}
                className="d-flex justify-content-center align-items-center"
              >
                <link.Icon size={25} />
              </Col>
              <Col sm={9}>
                <span className="m-0">{link.text}</span>
              </Col>
            </Row>
          </Accordion.Header>
          <Accordion.Body style={{ paddingRight: 0 }}>
            {link.children.map((clink) => (
              <React.Fragment>
                {clink.children && <DropDownLink link={clink} />}
                {!clink.children && <SingleLink link={clink} />}
              </React.Fragment>
            ))}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </React.Fragment>
  );
};

export default DropDownLink;
